<template>
  <div
    class="min-h-[calc(100vh_-_12rem)] flex flex-col px-4 md:px-10 lg:px-28 md:pt-18 lg:pt-24 pt-4 overflow-y-auto"
  >
    <Teleport to="body">
      <div
        class="w-full h-full min-h-screen gradient radial from-linear absolute top-0 left-0"
      ></div>
    </Teleport>
    <div class="w-full md:w-9/12 lg:5/12 max-w-[900px] mx-auto relative z-10">
      <h1
        class="text-headline-medium lg:text-display-small text-center text-white opacity-[0.87] mb-4 md:mb-9"
      >
        {{ $t("whoTitle") }}
      </h1>
      <section class="flex flex-col gap-y-4 md:gap-y-8">
        <p
          class="text-white opacity-[0.87] text-body-medium text-justify lg:text-body-big break-normal"
        >
          {{ $t("whoPart") }}
        </p>
        <img src="@/assets/pngs/abu-media.png" class="w-full" />
      </section>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped></style>
